import { render } from "./ClaimTokenModal.vue?vue&type=template&id=49c4fe6d"
import script from "./ClaimTokenModal.vue?vue&type=script&lang=js"
export * from "./ClaimTokenModal.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__